import { NOT_FOUND } from 'redux-first-router';

import { routes as adultProfileRoutes } from '../adultProfile';
import { routes as advancementRoutes } from '../advancement';
import { routes as editAdvancementRoutes } from '../advancementReport';
import calendarRoutes from '../calendar/routes';
import {
  SHOW_ACTIVITIES_MENU,
  SHOW_COUNSELED_YOUTH,
  SHOW_DASHBOARD,
  SHOW_USER_PERMISSIONS,
} from '../config';
import { routes as councilUnitsRoutes } from '../councilUnits';
import eventsRoutes from '../events/routes';
import featureFlagRoutes from '../featureFlags/routes';
import PositionsRoutes from '../leadershipPositions/routes';
import meritBadgeCounselorsRoutes from '../meritBadgeCounselors/routes';
import { routes as MessagingRoutes } from '../messaging';
import { TestOffline } from '../offline';
import { routes as paymentLogsRoutes } from '../paymentLogs';
import { routes as permissionsManagerRoutes } from '../permissionManager/routes';
import { routes as personProfileRoutes } from '../personProfile';
import { routes as profileRoutes } from '../profile';
import { routes as ReferencesRoutes } from '../references/routes';
import { routes as reportsRoutes } from '../reports';
import rosterLiteRoutes from '../roster-lite/routes';
import rosterV2Routes from '../roster-v2/routes';
import { routes as settingsRoutes } from '../settings';
import { UnderConstruction } from '../shared';
import { routes as userRoutes } from '../user';
import { routes as youthProfileRoutes } from '../youthProfile';
import ErrorPage from './components/ErrorPage';

const dashboardRoutes = SHOW_DASHBOARD ? require('../dashboard').routes : {};
const activitiesRoutes = SHOW_ACTIVITIES_MENU
  ? require('../activities').routes
  : {};
const rolesRoutes = SHOW_USER_PERMISSIONS ? require('../roles').routes : {};

const counseledYouth = SHOW_COUNSELED_YOUTH
  ? require('../counseledYouth/routes').default
  : {};

export default {
  ...featureFlagRoutes,
  ...dashboardRoutes,
  ...userRoutes,
  ...profileRoutes,
  ...advancementRoutes,
  ...rosterLiteRoutes,
  ...rosterV2Routes,
  ...activitiesRoutes,
  ...eventsRoutes,
  ...reportsRoutes,
  ...calendarRoutes,
  ...rolesRoutes,
  ...settingsRoutes,
  ...editAdvancementRoutes,
  ...youthProfileRoutes,
  ...adultProfileRoutes,
  ...personProfileRoutes,
  ...councilUnitsRoutes,
  ...meritBadgeCounselorsRoutes,
  ...counseledYouth,
  ...paymentLogsRoutes,
  ...permissionsManagerRoutes,
  ...MessagingRoutes,
  ...PositionsRoutes,
  ...ReferencesRoutes,
  [NOT_FOUND]: {
    Component: ErrorPage,
    standalone: true,
  },
  // TODO: remove these once their respective modules have been created
  serviceHoursPlaceholder: {
    path: '/service-hours',
    Component: UnderConstruction,
    titleId: 'page.serviceHours',
  },
  upgradePlanPlaceholder: {
    path: '/upgrade-plan',
    Component: UnderConstruction,
    titleId: 'page.upgradePlan',
  },
  offline: {
    path: '/offline',
    Component: TestOffline,
    titleId: 'page.myAccount',
  },
};
